import React from 'react';
import PropTypes from 'prop-types';
import './OverlayPanel.scss';

class OverlayPanel extends React.PureComponent {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    this.escFunction = this.escFunction.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.props.onClose(event);
    }
  }

  render() {
    // Key events are added to the document
    /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
    return (
      <div
        className="tuc-overlay-panel"
        onClick={this.props.onClose}
        role="dialog"
      />
    );
    /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
  }
}

export default OverlayPanel;
